import AppButton, { AppButtonProps } from './AppButton';

export type LoadingButtonProps = AppButtonProps;

/** Primary contained button with optional loading spinner. */
export default function LoadingButton(props: LoadingButtonProps) {
  return <AppButton variant="contained" {...props} />;
}
